import { createContext, useContext } from 'react';

/**
 * @typedef {{
 *   showToast: (msg: string) => void,
 *   toast: string | null,
 *   pendingCount: number,
 *   setPendingCount: (n: number) => void,
 *   dateFormat: string,
 *   setDateFormat: (setting: string) => void,
 *   dateFormatSetting: string,
 *   setDateFormatSetting: (setting: string) => void,
 *   onboardingStatus: Record<string, boolean> | null,
 *   setOnboardingStatus: (status: Record<string, boolean> | null) => void,
 *   privateMode: boolean,
 *   setPrivateMode: (on: boolean) => void,
 *   developerMode: boolean,
 *   setDeveloperMode: (on: boolean) => void,
 *   currencyRates: Array<{ code: string, symbol: string, decimalPlaces: number, rate: number | null }>,
 *   setCurrencyRates: (currencies: Array<{ code: string, symbol: string, decimalPlaces: number, rate: number | null }>) => void,
 *   baseCurrency: string | null,
 *   setBaseCurrency: (base: string | null) => void,
 *   bootstrapStatus: 'loading' | 'ready' | 'no-account' | 'error',
 *   setBootstrapStatus: (status: 'loading' | 'ready' | 'no-account' | 'error') => void,
 *   appVersion: string | null,
 *   setAppVersion: (version: string | null) => void,
 * }} AppCtxValue
 */

/** @type {React.Context<AppCtxValue | null>} */
export const AppCtx = createContext(null);

export function useAppCtx() {
	const ctx = useContext(AppCtx);
	if (!ctx) {throw new Error('useAppCtx must be used within AppCtx.Provider');}
	return ctx;
}
